import Signin from './SignIn'
import Logout from './Logout'

const modules = {
    Signin,
    Logout
}

const state = {}

const mutations = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules
}
